import React, { useEffect } from "react";
import { Formik, replace } from "formik";
import { useState, useRef } from "react";
// import * as Yup from "yup";
import { baseUrl } from "../../utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoIosArrowRoundForward } from "react-icons/io";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { boolean } from "yup";
import useBreakpoint from "../../utils/useBreakpoint";
import * as Yup from "yup";
import CoinBlue from "../../images/Carbo-X-Blue.svg";
import CoinGreen from "../../images/Carbo-X-Green.svg";
import { BsCheckLg } from "react-icons/bs";
import BlueTokenAbi from "../../abis/CarboXBlue.json";
import GreenTokenAbi from "../../abis/CarboXGreen.json";
import { errors, ethers } from "ethers";

function BuyTokenPage({ setShowFarmform, setShowUserform, setUserId }) {
  const [isContact, setIsContact] = useState(false);
  const [isAddress, setIsAdress] = useState(false);
  const [isType, setIstype] = useState(false);
  const [file, setFile] = useState(null);
  const [imageData, setImageData] = useState(null);
  const fileInputRef = useRef();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState("green");
  const [greenTokenAmount, setGreenTokenAmount] = useState("");
  const [blueTokenAmount, setBlueTokenAmount] = useState("");
  const [error, setError] = useState("");
  const [checked, setChecked] = useState(false);

  const organizationId = useSelector(
    (state) => state?.auth?.user?.organizations?.[0]?._id
  );

  const { user } = useSelector((state) => state.auth);
  const contractsData = useSelector((state) => state?.auth?.contracts);

  const navigate = useNavigate();

  const { isMobile, isTable } = useBreakpoint();

  const handleImgInput = async (e) => {
    const file = {
      url: URL.createObjectURL(e.target.files[0]),
      details: e.target.files[0],
    };
    console.log(file);
    setFile(file);
  };

  const uploadToCdn = async (file) => {
    let formData = new FormData();
    formData.append("item", file?.details);
    const endPoint = "https://media.agrotrust.io/content/";
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(endPoint, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "content-type": "multipart/form-data",
        },
      });
      // setImageData(response.data);
      return response.data?.result?.url;
    } catch (error) {
      console.log(error);
    }
  };

  const handleCardSelect = (color) => {
    setSelected(color);
  };

  // const checkError = () => {
  //   if (greenTokenAmount === undefined || !greenTokenAmount?.length) {
  //     setError("Please Enter CarboX Green Token");
  //     return;
  //   }

  //   if (blueTokenAmount === undefined || !blueTokenAmount?.length) {
  //     setError("Please Enter CarboX Blue Token");
  //     return;
  //   }
  // };

  // const handleGreenInput = (e) => {
  //   setGreenTokenAmount(e.target.value);
  // };

  // const handleBlueInput = (e) => {
  //   setBlueTokenAmount(e.target.value);
  // };

  const BuyToken = async (tokenType) => {
    console.log(tokenType, greenTokenAmount, blueTokenAmount);
    let formattedGreenAmount = greenTokenAmount
      ? ethers.utils.parseEther(greenTokenAmount)
      : "";
    let formattedBlueAmount = blueTokenAmount
      ? ethers.utils.parseEther(blueTokenAmount)
      : "";

    console.log(formattedGreenAmount, formattedBlueAmount);

    // checkError();

    toast.promise(
      new Promise(async (resolve, reject) => {
        setLoading(true);
        try {
          if (user?.signer && tokenType === "green") {
            let buyTransaction = await contractsData?.greenToken?.transferFrom(
              "0x100dF25e6beF94d5c82e1C411DF05E0536130BFf",
              user?.signer,
              formattedGreenAmount
            );
            await buyTransaction.wait();
            setLoading(false);
            resolve(buyTransaction);
            // window.location.reload(false);
          }
          if (user?.signer && tokenType === "blue") {
            let buyTransaction = await contractsData?.blueToken.transferFrom(
              "0x100dF25e6beF94d5c82e1C411DF05E0536130BFf",
              user?.signer,
              formattedBlueAmount
            );
            await buyTransaction.wait();
            setLoading(false);
            resolve(buyTransaction);
            // window.location.reload(false);
          }
        } catch (error) {
          setLoading(false);
          reject(error);
          console.log(error);
        }
      }),
      {
        pending: "Buying Token...",
        success: "Token Purchased successfully 👌",
        error: "Error Purchasing Token 🤯",
      }
    );
  };

  return (
    <form className="buy-burn-wrapper">
      <div className="welcome-card">
        <h5>
          Buy <span className="red-text">Carbo-X tokens </span>
        </h5>
        <p>
          Carbo-X Green is for Compliance Market and Carbo-X blue is for
          Voluntary Market
        </p>
      </div>
      <div className="card-wrapper">
        <div
          className={`${
            selected === "green" && "active"
          } card green-card shadow-card`}
          onClick={() => handleCardSelect("green")}
        >
          <BsCheckLg className={`checkMark`} />
          <img src={CoinGreen} alt="Welcome" />
          <h2 className="green-text">Carbo-X Green</h2>
        </div>

        <div
          className={`${
            selected === "blue" && "active"
          } card blue-card shadow-card`}
          onClick={() => handleCardSelect("blue")}
        >
          <BsCheckLg className={`checkMark`} />
          <img src={CoinBlue} alt="Welcome" />
          <h2 className="blue-text">Carbo-X Blue</h2>
        </div>
      </div>

      <div className="bottom-wrapper">
        <div className="content-wrapper">
          <h4>
            Buy{" "}
            <span
              className={`${selected === "green" ? "green-text" : "blue-text"}`}
            >
              Carbo-X {selected === "green" ? "Green" : "Blue"}
            </span>{" "}
            Token
          </h4>
          <p>
            <input
              checked={checked}
              onClick={() => setChecked((prev) => !prev)}
              type={"checkbox"}
              className="outline-btn "
            />
            I agree to{" "}
            <a
              href="https://carbox-landing-page.vercel.app/terms"
              rel="noreferrer"
              target={"_blank"}
              className="text-blue-500"
            >
              terms and conditions
            </a>
          </p>
        </div>
        <label className="form-wrapper" htmlFor="token">
          <div className="inner-wrapper">
            <input
              id="token"
              type="number"
              placeholder={`Enter Carbo-X ${
                selected === "green" ? "Green" : "Blue"
              } Token`}
              value={selected === "green" ? greenTokenAmount : blueTokenAmount}
              onChange={(e) =>
                selected === "green"
                  ? setGreenTokenAmount(e.target.value)
                  : setBlueTokenAmount(e.target.value)
              }
              autoComplete="given-name"
              className={
                error ===
                `Please Enter CarboX ${
                  selected === "green" ? "Green" : "Blue"
                } Token`
                  ? "shadow-sm block w-full sm:text-sm border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500"
                  : "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-l-md"
              }
            />
            <button
              disabled={checked ? false : true}
              onClick={() =>
                selected === "green" ? BuyToken("green") : BuyToken("blue")
              }
              type="button"
              className={`new-btn disabled:cursor-not-allowed`}
            >
              <span className="">{loading ? "Buying..." : "Buy"}</span>
            </button>
            {error ===
              `Please Enter CarboX selected === "green" ? "Green" : "Blue" Token` && (
              <div className="text-red-500">{error}</div>
            )}
          </div>
        </label>
      </div>
    </form>
  );
}

export default BuyTokenPage;
